package pl.mothdigital.neuronowi.components.sections.contactdetails

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.text.*
import com.varabyte.kobweb.silk.style.*
import com.varabyte.kobweb.silk.style.breakpoint.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import pl.mothdigital.neuronowi.common.resources.StringResources
import pl.mothdigital.neuronowi.components.text.*
import pl.mothdigital.neuronowi.components.widgets.*
import pl.mothdigital.neuronowi.theme.*
import pl.mothdigital.neuronowi.theme.text.*

@Composable
fun ContactDetailsSection() {
    Section(
        attrs = Modifier
            .fillMaxWidth()
            .padding(topBottom = 3.cssRem, leftRight = 6.percent)
            .alignItems(com.varabyte.kobweb.compose.css.AlignItems.Center)
            .toAttrs()
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .flexWrap(FlexWrap.Wrap)
                .gap(3.cssRem)
                .displayIfAtLeast(Breakpoint.MD)
                .padding(leftRight = 9.percent),
            horizontalArrangement = Arrangement.Center,
        ) {
            Column(
                modifier = Modifier
                    .flex(1)
                    .padding(top = 1.cssRem)
                    .minWidth(320.px),
                verticalArrangement = Arrangement.spacedBy(1.2.cssRem)
            ) {
                ContactInfoList()
            }
            Spacer()
            Column(
                modifier = Modifier
                    .flex(1)
                    .minWidth(300.px),
                verticalArrangement = Arrangement.spacedBy(0.4.cssRem)
            ) {
                AvailabilityInfo()
            }
        }

        Column(
            modifier = Modifier
                .fillMaxWidth()
                .displayUntil(Breakpoint.MD)
                .padding(leftRight = 9.percent)
        ) {
            Column(
                modifier = Modifier.padding(top = 1.cssRem).minWidth(320.px),
                verticalArrangement = Arrangement.spacedBy(1.2.cssRem)
            ) {
                ContactInfoList()
            }
            Column(
                modifier = Modifier.padding(top = 2.cssRem),
                verticalArrangement = Arrangement.spacedBy(0.4.cssRem)
            ) {
                AvailabilityInfo()
            }
        }
    }
}

@Composable
private fun AvailabilityInfo() {
    AppH3 { Text("Godziny otwarcia") }

    SpanText("Poniedziałek: 09:00–19:00")
    SpanText("Wtorek: 09:00–19:00")
    SpanText("Środa: 09:00–19:00")
    SpanText("Czwartek: 09:00–19:00")
    SpanText("Piątek: 09:00–19:00")
    SpanText("Sobota: Zamknięte")
    SpanText("Niedziela: Zamknięte")

    VerticalSpacer(1.cssRem)

    AppP { Text("Zadzwoń lub napisz, by umówić wizytę lub zadać pytanie.") }
}

@Composable
private fun ContactInfoList() {
    ContactInfoItem(icon = { FaMapLocation() }, text = "Fabryczna 17a/1, 65-410 Zielona Góra")
    ContactInfoItem(icon = { FaEnvelope() }, text = "neuronowi.zg@gmail.com")
    ContactInfoItem(
        icon = { FaSquarePhone() },
        text = "${StringResources.MAGDALENA_NOWIK}: ${StringResources.MAGDALENA_NOWIK_PHONE}"
    )
    ContactInfoItem(
        icon = { FaSquarePhone() },
        text = "${StringResources.ZAKLINA_WYKRET}: ${StringResources.ZAKLINA_WYKRET_PHONE}"
    )
    ContactInfoItem(
        icon = { FaSquarePhone() },
        text = "${StringResources.EWA_SOFINSKA}: ${StringResources.EWA_SOFINSKA_PHONE_NUMBER}"
    )
    ContactInfoItem(
        icon = { FaSquarePhone() },
        text = "${StringResources.MARTA_DYBALSKA}: ${StringResources.MARTA_DYBALSKA_PHONE_NUMBER}"
    )
    ContactInfoItem(
        icon = { FaSquarePhone() },
        text = "${StringResources.JULIA_SIUTA}: ${StringResources.JULIA_SIUTA_PHONE_NUMBER}"
    )
    ContactInfoItem(
        icon = { FaSquarePhone() },
        text = "${StringResources.PAULINA_KONIECZNA}: ${StringResources.PAULINA_KONIECZNA_PHONE_NUMBER}"
    )
    ContactInfoItem(
        icon = { FaSquarePhone() },
        text = "${StringResources.RADOSLAW_NITSCHKE}: ${StringResources.RADOSLAW_NITSCHKE_PHONE_NUMBER}"
    )
    ContactInfoItem(
        icon = { FaSquarePhone() },
        text = "${StringResources.PATRYCJA_OCHRYNIUK}: ${StringResources.PATRYCJA_OCHRYNIUK_PHONE_NUMBER}"
    )
    ContactInfoItem(
        icon = { FaSquarePhone() },
        text = "${StringResources.ANNA_PETRUS}: ${StringResources.ANNA_PETRUS_PHONE_NUMBER}"
    )
    ContactInfoItem(
        icon = { FaSquarePhone() },
        text = "${StringResources.MAGDALENA_BANACH}: ${StringResources.MAGDALENA_BANACH_PHONE_NUMBER}"
    )
}

@Composable
private fun ContactInfoItem(icon: @Composable () -> Unit, text: String) {
    Row(
        modifier = Modifier.fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically
    ) {
        icon()
        HorizontalSpacer((0.8).cssRem)
        SpanText(
            text = text,
            modifier = NoWrapTextStyle.toModifier()
                .fontWeight(FontWeight.Normal)
                .fontSize(1.cssRem)
                .color(SiteTheme.green._900)
        )
    }
}
